import { render } from "./PrestadorForm.vue?vue&type=template&id=dd2ee4d4&scoped=true"
import script from "./PrestadorForm.vue?vue&type=script&lang=js"
export * from "./PrestadorForm.vue?vue&type=script&lang=js"

import "./PrestadorForm.vue?vue&type=style&index=0&id=dd2ee4d4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2ee4d4"]])

export default __exports__